<template>
  <v-chart
    class="line_chart"
    :option="lineOptions"
    :style="{ width: chartStyle.width, height: chartStyle.height }"
    :loading="loading"
    :loadingOptions="lineLoadingOptions"
    @click="echartsClick"
    ref="lineChartDom"
  />
</template>

<script>
import { ref } from "vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
} from "echarts/components";
use([
  CanvasRenderer,
  BarChart,
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
]);
import VChart from "vue-echarts";
export default {
  props: {
    loading: Boolean,
    lineOptions: Object,
    chartStyle: {
      type: Object,
      default(){
        return {
            width: "1000px",
            height: "300px",
        }
      },
    },
  },
  components: {
    VChart,
  },
  setup(props,ctx) {
    console.log(props);
    const lineLoadingOptions = ref({
      text: "Loading…",
      color: "#4ea397",
      maskColor: "rgba(255, 255, 255, 0.4)",
    });
    const echartsClick = (params)=>{
      ctx.emit('handel',{
        params
      })
    }
    return {
      lineLoadingOptions,
      echartsClick
    };
  },
};
</script>

<style>
</style>